export default {"src":"/_next/static/media/pl.67962836.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};